import React from "react";
import { LegalPage } from "./legal/LegalPage";

const SecurityCiber = () => <LegalPage namespace="legalSecurityCiber" />;

export default SecurityCiber;
